import { useEffect } from "react";

export function useOnEscapeKeyDown(handleEscKeyDown: undefined | (() => void)) {
  useEffect(() => {
    if (!handleEscKeyDown) {
      return;
    }
    const handleEscKeyDown_ = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        handleEscKeyDown();
      }
    };
    document.addEventListener("keydown", handleEscKeyDown_, false);
    return () => document.removeEventListener("keydown", handleEscKeyDown_, false);
  }, [handleEscKeyDown]);
}
